import React from "react";
import { H2, Text, Flex, Button, Container } from "@atoms";

// == Types ================================================================

// == Constants ============================================================

// == Component ============================================================

export default function ErrorLoading() {
  return (
    <Container>
      <Flex alignItems="center" flexDirection="column" p={5}>
        <H2 color="primary" fontSize={7} mb={4}>
          Oops!
        </H2>
        <Text as="p" fontSize={3} mb={4} textAlign="center">
          We&apos;re experiencing issues and the site is currently unavailable.
          <br /> We are working on a fix and&#10; expect to be back as soon as possible. <br />
          Thank you for your patience.
        </Text>
        <Button as="a" href="/">
          Return Home
        </Button>
      </Flex>
    </Container>
  );
}

// == Styles ===============================================================
